import {Action, getModule, Module, Mutation, VuexModule} from "vuex-module-decorators";
import store from '@/store'
import {SelectListItem} from "@/api/appService";
import api from '@/api/index'


class EnumValueFetchState {

  private typeName: string;
  private loading = true;
  private _items: SelectListItem[] = []
  private _promise?: Promise<SelectListItem[]>


  constructor(typeName: string) {
    this.typeName = typeName;
  }

  fetch(): Promise<SelectListItem[]> {
    return new Promise<SelectListItem[]>((resolve, reject) => {
      if (!this.loading) {
        resolve(this._items)
      } else {
        api.enumService.getValues({typeName: this.typeName}).then(res => {
          this.loading = false;
          this._items = res
          resolve(res)
        })
      }
    })
  }

  get isOnLoading() {
    return this.loading;
  }

  get promise(): Promise<SelectListItem[]> {
    if (this._promise) {
      return this._promise;
    } else {
      this._promise = this.fetch();
      return this._promise;
    }
  }

  get items():SelectListItem[] {
    return this._items;
  }

}

@Module({dynamic: true, store, name: 'enumValues'})
class EnumValues extends VuexModule {

  public enumValues: { [key: string]: SelectListItem[] } = {}
  private allStates: { [key: string]: EnumValueFetchState } = {}


  @Mutation
  private SET_ENUM_VALUE(key: string, values: SelectListItem[]) {
    this.enumValues[key] = values;
  }


  @Action
  public fetch(typeName: string): Promise<SelectListItem[]> {
    return new Promise<SelectListItem[]>((resolve, reject) => {
      const cacheValue = this.enumValues[typeName]
      if (cacheValue) {
        resolve(cacheValue)
      } else {
        let state = this.allStates[typeName];
        if (!state) {
          state = new EnumValueFetchState(typeName)
          this.allStates[typeName] = state
        }
        if(state.isOnLoading){
          state.promise.then(res=>{
            this.enumValues[typeName]  = res;
            resolve(res)
          })
        } else {
          resolve(state.items)
        }


      }

    })
  }

}

export const EnumValuesModule = getModule(EnumValues)
